import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, MapPinIcon, ShoppingBagIcon, XIcon } from 'lucide-react';
const purchases = [['Tomás G.', 'Córdoba, Argentina', 'Combo Completo Futsal'], ['Matías P.', 'Rosario, Argentina', 'Combo + Alto Rendimiento'], ['Lucas M.', 'Mendoza, Argentina', 'Combo Completo Futsal'], ['Julián A.', 'Mar del Plata, Argentina', 'Combo + Alto Rendimiento'], ['Emanuel F.', 'San Miguel de Tucumán, Argentina', 'Combo Completo Futsal']];
export function FloatingElements() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [number, setNumber] = useState(0);
  const [cta, setCta] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const initialTimer = window.setTimeout(() => setVisible(true), 6000);
    return () => window.clearTimeout(initialTimer);
  }, [dismissed]);
  useEffect(() => {
    if (!visible || dismissed) return;
    const hideTimer = window.setTimeout(() => setVisible(false), 5500);
    const nextTimer = window.setTimeout(() => {
      setNumber(value => (value + 1) % purchases.length);
      setVisible(true);
    }, 14500);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(nextTimer);
    };
  }, [visible, dismissed]);
  useEffect(() => {
    const onScroll = () => setCta(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const [name, city, plan] = purchases[number];
  return <>
      <AnimatePresence data-id="element-189">
        {visible && !dismissed && <motion.aside initial={{
        opacity: 0,
        y: 32,
        scale: 0.94
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 32,
        scale: 0.94
      }} className="fixed bottom-4 left-4 z-[60] w-[min(310px,calc(100vw-2rem))] overflow-hidden rounded-2xl border-2 border-gold bg-primary p-3 pr-8 shadow-[0_18px_42px_rgba(7,59,92,.42)] ring-2 ring-gold/30" aria-live="polite" data-id="element-190">
            <div className="absolute inset-y-0 left-0 w-1.5 bg-gold" data-id="element-191" />
            <button onClick={() => setDismissed(true)} className="absolute right-1.5 top-1.5 rounded p-1 text-sky-200 transition-colors hover:bg-white/10 hover:text-white" aria-label="Cerrar notificación" data-id="element-192">
              <XIcon className="h-3.5 w-3.5" data-id="element-193" />
            </button>
            <div className="flex gap-3" data-id="element-194">
              <span className="rounded-full border-2 border-white/40 bg-gold p-2 text-primary shadow-sm" data-id="element-195">
                <ShoppingBagIcon className="h-5 w-5" data-id="element-196" />
              </span>
              <div data-id="element-197">
                <p className="flex items-center gap-1 text-[10px] font-extrabold uppercase tracking-[.12em] text-gold" data-id="element-198">
                  <CheckCircle2Icon className="h-3 w-3" data-id="element-199" /> Compra reciente
                </p>
                <p className="mt-1 text-xs leading-snug text-sky-50" data-id="element-200">
                  <b className="text-white" data-id="element-201">{name}</b> adquirió el libro digital{' '}
                  <b className="text-gold" data-id="element-202">{plan}</b>
                </p>
                <p className="mt-1 flex items-center gap-1 text-[10px] font-semibold text-sky-200" data-id="element-203">
                  <MapPinIcon className="h-3 w-3 text-gold" data-id="element-204" /> {city} · hace{' '}
                  {number * 7 + 2} min
                </p>
              </div>
            </div>
          </motion.aside>}
      </AnimatePresence>

      <AnimatePresence data-id="element-205">
        {cta && <motion.a href="#pricing" initial={{
        y: 80,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 80,
        opacity: 0
      }} className="fixed bottom-3 left-3 right-3 z-50 rounded-2xl bg-primary py-3.5 text-center font-display text-sm font-bold text-white shadow-lg shadow-primary/30 md:hidden" data-id="element-206">
            QUIERO MI COMBO FUTSAL →
          </motion.a>}
      </AnimatePresence>
    </>;
}